import React, { useRef } from 'react';
import { Button } from '../Button';

interface IFileUploadProps {
  onUpload: (file: any) => void;
  accept?: string;
  onClick?: () => void;
  label?: string;
  size?: 'large' | 'small';
  appearance?: 'primary' | 'secondary' | 'tertiary';
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
}

const FileUploadButton: React.FC<IFileUploadProps> = ({ onUpload, accept, onClick, label = 'Upload', appearance = 'primary', size = 'small', disabled, isLoading, className }) => {
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    onClick?.();
    if (hiddenFileInput && hiddenFileInput.current) {
      hiddenFileInput.current.value = '';
      hiddenFileInput.current.click();
    }
  };

  const handleChange = (event: any) => {
    const fileUploaded = event.target.files[0];
    onUpload(fileUploaded);
  };

  return (
    <>
      <Button label={label} type="button" appearance={appearance} size={size} disabled={disabled} isProcessing={isLoading} onClick={handleClick} className={className} />

      <input type="file" ref={hiddenFileInput} onChange={(evt) => handleChange(evt)} style={{ display: 'none' }} accept={accept} />
    </>
  );
};

export default FileUploadButton;
